import React from 'react';
import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  TablePagination
} from '@material-ui/core';
import ViewColumn from 'helpers/ViewColumn';
import useLocalStorageTableCells from 'hooks/useLocalStorageTableCells';
import QuotesQueueResultTableRow from './QuotesQueueResultTableRow';
import { defaultTableCells } from './helpers/headTableCells';
import { useStyles } from './styles';


const QuotesQueueResultTable = ({
  failedTasks,
  countOfFailedQueueTasks,
  handleChangePage,
  handleChangeRowsPerPage,
  rowsPerPage,
  currentPage
}) => {
  const classes = useStyles();
  const { headTableCells, setHeadTableCells } = useLocalStorageTableCells('QueueTableCells', defaultTableCells);

  return (
    <Card className="mt-5 p-7">
      <div className="flex items-center justify-between">
        <Typography className="mb-5">
          <strong className="text-error mr-1">Failed create quote for:</strong>
        </Typography>
        <ViewColumn storageKey="QueueTableCells" tableCells={headTableCells} setHeadTableCells={setHeadTableCells} />
      </div>
      <TableContainer className="w-full overflow-x">
        <Table className={classes.tableRoot}>
          <TableHead>
            <TableRow>
              {headTableCells.map((cell) => (
                cell.display
                  ? <TableCell className={cell.align} width={cell.width} key={cell.label}>{cell.label}</TableCell>
                  : null
              ))}
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {failedTasks.map((task) => (
              <QuotesQueueResultTableRow task={task} tableCells={headTableCells} key={`task-${task._id}`} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 20, 40, 80, 100]}
        component="div"
        className={classes.paginationContainer}
        count={countOfFailedQueueTasks}
        rowsPerPage={rowsPerPage}
        page={currentPage - 1}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Card>
  );
};

export default QuotesQueueResultTable;
